import { Grid, Typography } from '@mui/material';
import Observer from '../../shared/Observer/Observer';
import ContentTitle from '../../layout/ContentTitle/ContentTitle';

interface Props {
  children?: React.ReactElement<unknown>;
}

const texts = [
  "株式会社サプライムへようこそ！",
  "当社は、2024年6月26日、新横浜に設立いたしました。",
  "コンピュータシステム、及びソフトウェアの設計・開発・販売及び",
  "コンサルティングを行う会社です。",
  "　",
  "　",
  "サプライムは、最先端の情報技術の力を使って、",
  "世の中の人や社会が、より豊かになることを実現するエキスパート集団です。",
  "Webアプリケーション開発、スマホ・タブレット、組み込み開発まで、",
  "幅広く対応し、必要な技術をご提供します。",
  "　",
  "　",
  "私たちの力を提供することで、クライアントやユーザーの",
  "「できること」",
  "を増やし、社会の可能性を広げていきたいと考えています。"
]

export default function MessageSection(props: Props) {
  return (
    <Grid container>
      <Grid size={{ md: 12, lg: 12 }}>
        <Observer>
          <ContentTitle title="MESSAGE" subTitle='メッセージ' />
        </Observer>
      </Grid>
      <Grid size={{ md: 12, lg: 12 }} sx={{ marginTop: '2rem', marginBottom: '2rem', padding: '2rem' }}>
        {texts.map((t, index) => {
          return (
            <Observer key={index} timeout={(index + 1) * 100}>
              <Typography
                variant="body2"
                lineHeight={2}
                sx={(theme) => ({
                  fontSize: '1.1rem',
                  [theme.breakpoints.up('md')]: {
                    fontSize: '1.25rem',
                  },
                })}
              >
                {t}
              </Typography>
            </Observer>
          )
        })}
      </Grid>
    </Grid>
  )
}